import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import { Context, Transitions } from "../../types"
import { generateSelfRefScope } from "../../../../../../services/ready-services/studyPlan/studyPlanServices"

export const beforeLogin: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  on: {
    SELECT_USER: [
      {
        target: "#StudyPlan.get_program_courses",
        actions: assign((_ctx, evt) => {
          return {
            selfRefScope: generateSelfRefScope(
              evt.newRole,
              evt.newDistrictId,
              evt.newSchoolId,
              evt.newTeacherId,
              evt.newClassId,
              evt.newStudentId
            )
          }
        })
      }
    ]
  }
}
